import { colors } from '../cssVariables'

// Define the custom checkbox component in your theme
export const Checkbox = {
  baseStyle: {
    control: {
      _checked: {
        _hover: {
          bg: 'transparent',
        },
      },
    },
    label: {
      // Default label styles
    },
    container: {
      alignItems: 'center', // Keep vertical center alignment for all variants
    },
  },
  variants: {
    custom: {
      control: {
        borderColor: colors.colorB3, // Default border color
        _checked: {
          bg: 'transparent', // Make background transparent
          borderColor: colors.colorA1, // Checked border color
          color: colors.colorA1, // Checkmark color
          _hover: {
            bg: 'transparent',
            borderColor: colors.colorA1,
          },
        },
        _hover: {
          borderColor: colors.colorA1, // Hover border color
        },
        _focus: {
          boxShadow: 'none', // Remove default focus shadow
          borderColor: colors.colorA1,
        },
        _disabled: {
          opacity: 0.6,
          cursor: 'not-allowed',
        },
      },
      label: {
        marginLeft: '20px', // Gap between checkbox icon and text
      },
    },
  },
  defaultProps: {
    // Set "custom" as the default variant
    variant: 'custom',
  },
}
